import _Runfest from './Runfest'
import _Link from './view/components/Link'
import _Router from './view/components/Router'

export const Router = _Router
export const Link = _Link
export const Runfest = _Runfest
export const Router3Runfest = _Runfest
export const syncHistoryWithStore = _Runfest.syncHistoryWithStore
